// src/containers/Chat/MessageActionsMenu.jsx
import React, { useEffect, useRef, useState } from 'react';
import Flyover from '../../components/UI/Flyover';

export default function MessageActionsMenu({
  onViewReads, onCopy, onDelete, onReply, onStarToggle, starred = false, openToRight = false
}) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (!btnRef.current) return;
      // если кликнули ВНЕ flyover и ВНЕ кнопки — закрываем
      const fly = document.querySelector('.msg-flyover-root');
      if (fly && (fly.contains(e.target) || btnRef.current.contains(e.target))) return;
      setOpen(false);
    };
    const onEsc = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('click', onDoc);
    document.addEventListener('keydown', onEsc);
    return () => {
      document.removeEventListener('click', onDoc);
      document.removeEventListener('keydown', onEsc);
    };
  }, []);

  const clickItem = (fn) => (e) => {
    e.preventDefault();
    e.stopPropagation();      // ⬅️ ключевое
    fn?.();
    setOpen(false);
  };

  return (
    <div className="msg-menu">
      <button
        ref={btnRef}
        className="msg-menu__trigger"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen(v => !v); }}
        aria-label="Действия"
      >⋯</button>

      {open && (
        <Flyover
          anchorRef={btnRef}
          onClose={() => setOpen(false)}
          preferredPlacement="bottom"
          align={openToRight ? 'end' : 'start'}
          width={220}
          className="msg-flyover-root"   // ⬅️ чтобы отличать от бэкдропа
          backdropClassName="msg-flyover__backdrop"
          zIndex={1500}
        >
          <div className="msg-flyover">
            <button className="msg-flyover__item" onClick={clickItem(onReply)}>↩ Ответить</button>
            <button className="msg-flyover__item" onClick={clickItem(onViewReads)}>👁 Кто прочитал</button>
            <button className="msg-flyover__item" onClick={clickItem(onCopy)}>📋 Скопировать</button>
            <button className="msg-flyover__item" onClick={clickItem(() => onStarToggle?.(!starred))}>
              {starred ? '★ Убрать из избранного' : '☆ В избранное'}
            </button>
            {onDelete && <button className="msg-flyover__item danger" onClick={clickItem(onDelete)}>🗑 Удалить</button>}
          </div>
        </Flyover>
      )}
    </div>
  );
}
